// TerminateButton.jsx
import React, { useState } from 'react';
import config from '../utils/config';
import { useAuth } from '../utils/AuthContext/AuthContext'; 

const TerminateButton = ({ formId, onTerminateSuccess, onTerminated }) => {
  const { token } = useAuth();
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleTerminate = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.apiBaseUrl}/formdata/${formId}/terminate`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Failed to terminate contract');
      }
      const data = await response.json();
      onTerminateSuccess && onTerminateSuccess(data);
      onTerminated();
      setShowConfirm(false);
    } catch (error) {
      console.error(error);
      alert('Error terminating contract');
    }
    setLoading(false);
    setShowConfirm(false);
  };

  return (
    <>
      <div className=''>
        <button 
            onClick={() => setShowConfirm(true)}
            className=" text-red-800 text-[14px] w-auto rounded hover:border-b-1 hover:border-red-700"
        >
            Mark as Terminated →
        </button>
      </div>

      {showConfirm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md max-w-sm w-full">
            <h3 className="text-lg font-semibold mb-4">Confirm Setting Contract as Terminated</h3>
            <p className="mb-4">
            <strong>Note:</strong> Marking the contract as terminated only updates its status in our system. It does not legally terminate the contract. To fully terminate it, you must complete, sign, and send the official termination documents to the seller. 
            
            <br />
            <br />
            Do you still want to mark this contract as terminated?

            </p>
            <div className="flex justify-end gap-4">
              <button 
                onClick={() => setShowConfirm(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                onClick={handleTerminate}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-700"
                disabled={loading}
              >
                {loading ? 'Terminating...' : 'Yes, Terminate'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TerminateButton;
